module.exports = __webpack_public_path__ + "img/LogoFlaxeo-RVB-Blanc-turquoise.f22eee9e.webp";